// src/utils/followUtils.js
import {
    collection,
    addDoc,
    deleteDoc,
    query,
    where,
    getDocs,
    doc,
  } from "firebase/firestore";
  import { db } from "../firebase";
  
  const followsRef = collection(db, "follows");
  
  // ✅ Kullanıcı takip et
  export const followUser = async (followerId, followedId) => {
    if (followerId === followedId) return;
  
    const q = query(followsRef, where("followerId", "==", followerId), where("followedId", "==", followedId));
    const snap = await getDocs(q);
    if (!snap.empty) return; // zaten takip ediyor
  
    await addDoc(followsRef, {
      followerId,
      followedId,
      timestamp: new Date(),
    });
  };
  
  // ❌ Takibi bırak
  export const unfollowUser = async (followerId, followedId) => {
    const q = query(followsRef, where("followerId", "==", followerId), where("followedId", "==", followedId));
    const snap = await getDocs(q);
    snap.forEach(async (docSnap) => {
      await deleteDoc(doc(db, "follows", docSnap.id));
    });
  };
  
  // ❓ Takip ediyor mu?
  export const isFollowing = async (followerId, followedId) => {
    const q = query(followsRef, where("followerId", "==", followerId), where("followedId", "==", followedId));
    const snap = await getDocs(q);
    return !snap.empty;
  };
  
  // 👥 Kullanıcının takipçileri (userId'yi takip edenler)
  export const getFollowers = async (userId) => {
    const q = query(followsRef, where("followedId", "==", userId));
    const snap = await getDocs(q);
    return snap.docs.map((doc) => doc.data().followerId);
  };
  
  // 👣 Kullanıcının takip ettikleri
  export const getFollowing = async (userId) => {
    const q = query(followsRef, where("followerId", "==", userId));
    const snap = await getDocs(q);
    return snap.docs.map((doc) => doc.data().followedId);
  };